import React, { useState } from "react";
import { Modal, Form, Row, Col, Card } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { publishImage } from "../../helpers/imageupload";
import { getAsset } from "../../helpers/helper";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { ClearIcon } from "@mui/x-date-pickers";
import { images } from "../../constants";
import url from "../../config/axios";
import { useSelector } from "react-redux";

const AddServiceModal = ({ show, handleClose,id,Dataloaderfun }) => {
  const { name } = useSelector((state) => state.user);

  // Main state
  const [userdata, setUserData] = useState({
    userid: name._id,
    serviceArray: [
      {
        heading: "",
        detail: "",
        images: []
      }
    ]
  });

  // Extra display images state
  const [displayimg, setDisplayimg] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Update heading/detail
  const handleServiceChange = (e) => {
    const { name, value } = e.target;

    setUserData((prev) => {
      const updatedArray = [...prev.serviceArray];
      updatedArray[0][name] = value;

      return {
        ...prev,
        serviceArray: updatedArray
      };
    });
  };

  // Upload images
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const uploadedImages = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      // Save images inside serviceArray[0]
      setUserData((prev) => {
        const updatedArray = [...prev.serviceArray];
        updatedArray[0].images = uploadedImages;

        return {
          ...prev,
          serviceArray: updatedArray
        };
      });

      setDisplayimg(uploadedImages);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  // Remove selected image
  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);

    setDisplayimg(updatedImages);

    // update userdata serviceArray
    setUserData((prev) => {
      const updatedArray = [...prev.serviceArray];
      updatedArray[0].images = updatedImages;

      return {
        ...prev,
        serviceArray: updatedArray
      };
    });
  };

  // API call
  const PostUserdata = () => {
    url
      .put(
        `service/AddCertExpeSer/id/?id=${id}`,
        userdata
      )
      .then((res) => {
        if (res.data.success) {
          Dataloaderfun();
          handleClose();
          SuccessNotify("Service Added Successfully");
        }
      })
      .catch(() => {
        FailedNotify("Failed to Add Service Try Again");
        handleClose();
      });
  };

  return (
    <Modal show={show === 1} onHide={handleClose} centered size="lg">
      <Modal.Header
        className="text-white pt-1 pb-1"
        style={{ backgroundColor: "#0353A4" }}
        closeButton
      >
        <Modal.Title>Add Service</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Service Name */}
          <Form.Group className="mb-3">
            <Form.Label>Service Name / Project Title</Form.Label>
            <Form.Control
              type="text"
              name="heading"
              placeholder="Enter service or project name"
              value={userdata.serviceArray[0].heading}
              onChange={handleServiceChange}
            />
          </Form.Group>

          {/* Description */}
          <Form.Group className="mb-3">
            <Form.Label>Project Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="detail"
              placeholder="Describe your project"
              value={userdata.serviceArray[0].detail}
              onChange={handleServiceChange}
            />
          </Form.Group>

          {/* Image Upload */}
          <Col>
            <Row>
              <Col lg="9" className="me-auto">
                <Row>
                  <Col lg={3} className="mt-2 ms-1">
                    <Card
                      style={{
                        width: "6rem",
                        height: "6rem",
                        position: "relative",
                      }}
                      {...getRootProps()}
                      className="dropzone"
                    >
                      {isUploading ? (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.7)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            borderRadius: "0.5rem",
                          }}
                        >
                          <div
                            className="spinner-border text-primary"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                            role="status"
                          ></div>
                          <small className="mt-1">{uploadProgress}%</small>
                        </div>
                      ) : (
                        <>
                          <Card.Img className="imet-fit" src={images?.AddImage} />
                          <input
                            type="file"
                            {...getInputProps()}
                            multiple
                            style={{ display: "none" }}
                          />
                        </>
                      )}
                    </Card>
                  </Col>

                  {/* Display Uploaded Images */}
                  {displayimg.length > 0 && (
                    <Col lg={7} className="mt-1 d-flex flex-wrap">
                      {displayimg.map((image, index) => (
                        <Card
                          key={index}
                          className="me-2 mt-1"
                          style={{
                            width: "6rem",
                            height: "6rem",
                            border: "2px solid",
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="imet-fit upload-img mt-0"
                            src={getAsset(image)}
                            crossOrigin="anonymous"
                          />
                          <div className="close-btnone" onClick={() => removeImage(index)}>
                            <ClearIcon />
                          </div>
                        </Card>
                      ))}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={handleClose}
          style={{
            backgroundColor: "white",
            border: "1px solid red",
            color: "red",
          }}
        >
          Cancel
        </button>

        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={PostUserdata}
          style={{
            backgroundColor: "#0353A4",
            border: "1px solid #0353A4",
            color: "white",
          }}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddServiceModal;
